import React from 'react';
import styled from 'styled-components';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { Dropdown } from 'primereact/dropdown';
import { SelectItem } from 'primereact/selectitem';
import { Typography } from '../Typography';
import { InfoTooltip } from "../Tooltip/InfoTooltip";
import SelectIcon from '../../assets/select.svg'
import SelectOpenIcon from '../../assets/selectOpen.svg'

interface FormSelectProps extends FieldProps<string, FieldRenderProps<string>> {
  id?: string;
  items: SelectItem[];
  placeholder?: string
  appendTo?: string;
  label?: React.ReactNode
  tooltip?: React.ReactNode;
  itemTemplate?: (option: any) => React.JSX.Element;
  required?: boolean;
  border?: boolean
  filter?:boolean 

}

export const FormSelect: React.FC<FormSelectProps> = props => {
const {filter=false, } = props 
  const [open, setOpen] = React.useState(false);
  return (
    <Field
      type="select"
      initialValue={props.initialValue}
      render={(selectProps) => (
        <Container id={props.id}>
            {!!props.label && (
              <Label >
                <Typography variant="body6">
                  <label htmlFor={props.name} >{props.label} {props.required && <span style={{ color: '#6777FF' }}>*</span>}</label>
                </Typography>
                {props.tooltip && (

                  <InfoTooltip name={`select-tooltip-${props.name}`} tooltip={props.tooltip} />

                )}
              </Label>
            )}
              <StyledDropdown
                options={props.items}
                placeholder={props.placeholder}
                inputId={props.name}
                itemTemplate={props.itemTemplate}
                dropdownIcon={open ? <SelectOpenIcon /> : <SelectIcon />}
                value={selectProps.input.value}
                onChange={selectProps.input.onChange}
                onBlur={selectProps.input.onBlur}
                onFocus={selectProps.input.onFocus}
                name={selectProps.input.name}
                border
                filter={props.filter}
              />
        </Container>
      )}
      {...props}
    />
  );
}

const Container = styled.div`
  width:100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledDropdown = styled(Dropdown) <{ border?: boolean }>`
  border: ${({ border }) => (border ? '1px solid #6777FF80' : '1px solid #E9E9E9')};
  border-radius: 10px;

  .p-dropdown-item-label {
    width: 100% !important;
  }
`;


const Label = styled.div`
  display: flex;
  gap: 4px;
`;


